module.exports = __webpack_public_path__ + "img/info-sec01-img.dff823c5.png";